// src/pages/SupportPage.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiHelpCircle, FiMail, FiClock, FiShield, FiFileText, FiExternalLink } from 'react-icons/fi';
import './SupportPage.css';

const SupportPage = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="support-page">
      <div className="support-container">
        <div className="support-header">
          <FiHelpCircle className="support-icon" />
          <h1>{t('support.title')}</h1>
          <p className="support-intro">
            {t('support.intro')}
          </p>
        </div>

        <section className="faq-section">
          <h2>{t('support.faq.title')}</h2>

          <div className="faq-grid">
            <div className="faq-item">
              <h3>{t('support.faq.strava.title')}</h3>
              <p>{t('support.faq.strava.content')}</p>
            </div>

            <div className="faq-item">
              <h3>{t('support.faq.data.title')}</h3>
              <p>{t('support.faq.data.content')}</p>
            </div>

            <div className="faq-item">
              <h3>{t('support.faq.security.title')}</h3>
              <p>{t('support.faq.security.content')}</p>
            </div>

            <div className="faq-item">
              <h3>{t('support.faq.sync.title')}</h3>
              <p>{t('support.faq.sync.content')}</p>
            </div>

            <div className="faq-item">
              <h3>{t('support.faq.disconnect.title')}</h3>
              <p>{t('support.faq.disconnect.content')}</p>
            </div>

            <div className="faq-item">
              <h3>{t('support.faq.strategic.title')}</h3>
              <p>{t('support.faq.strategic.content')}</p>
            </div>
          </div>
        </section>

        <div className="support-grid">
          <section className="contact-section card">
            <div className="card__header">
              <FiMail />
              <h2>{t('support.contact.title')}</h2>
            </div>
            <div className="card__content">
              <p>{t('support.contact.intro')}</p>
              <div className="contact-info">
                <a href="mailto:support@podiumrun.com" className="contact-email">
                  support@podiumrun.com
                </a>
                <div className="contact-hours">
                  <FiClock />
                  <span>{t('support.contact.hours')}</span>
                </div>
              </div>
            </div>
          </section>

          <section className="links-section card">
            <div className="card__header">
              <FiShield />
              <h2>{t('support.policies.title')}</h2>
            </div>
            <div className="card__content">
              <nav className="links-nav">
                <Link to={i18n.language.startsWith('en') ? '/privacy-policy' : '/privacy'}
                  className="link-item">
                  <FiFileText />
                  <span>{t('support.policies.privacy')}</span>
                  <FiExternalLink className="external-icon" />
                </Link>

                <Link to={i18n.language.startsWith('en') ? '/terms-of-service' : '/terms'}
                  className="link-item">
                  <FiFileText />
                  <span>{t('support.policies.terms')}</span>
                  <FiExternalLink className="external-icon" />
                </Link>

                <a href="https://www.strava.com/legal/api"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-item">
                  <FiExternalLink />
                  <span>{t('support.policies.stravaApi')}</span>
                  <FiExternalLink className="external-icon" />
                </a>
              </nav>

              <p className="links-note">
                <strong>{t('support.policies.note')}</strong> {t('support.policies.noteContent')}
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
